module.exports = __webpack_public_path__ + "media/dashboard/assets/images/convergence_logo-7bb763e820c81f2258623792dc62941c.png";